var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 173,
    height: 64,
    viewBox: "0 0 1380 494",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2303_1893)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M412.648 205.728H26.6152V463.039H412.648V205.728Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.693 0.00720503L-0.00195312 79.8066L26.5983 205.707L404.294 125.908L377.693 0.00720503Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.872 148.653V267.525H507.319V124.38H552.546L596.321 241.59L640.51 124.38H684.285V267.525H655.453V148.028L610.226 267.525H578.896L533.879 148.653H533.872Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.815 148.035V124.387H849.865V148.035H791.358V267.532H762.315V148.035H703.808H703.815Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M934.735 121.89C980.376 121.89 1006.1 135.583 1010.25 170.849H980.994C977.261 150.308 962.116 144.5 934.728 144.5C904.226 144.5 884.52 154.665 884.52 188.478V203C884.52 236.196 903.812 247.399 934.728 247.399C961.07 247.399 976.427 242.418 981.197 222.712H1010.45C1005.27 256.526 979.955 270.016 934.728 270.016C884.106 270.016 855.267 250.724 855.267 196.16C855.267 141.595 884.099 121.89 934.728 121.89H934.735Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.872 343.64V462.513H507.319V319.368H552.546L596.321 436.578L640.51 319.368H684.285V462.513H655.453V343.016L610.226 462.513H578.896L533.879 343.64H533.872Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M839.49 319.375V341.985H745.717V378.499H817.918V400.281H745.717V439.91H840.317V462.52H716.667V319.375H839.483H839.49Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M851.542 438.872H867.929C874.776 428.496 880.795 408.58 880.795 371.862V319.375H1010.04V438.872H1029.34V493.639H1002.36V462.52H878.508V493.639H851.542V438.872ZM907.762 343.023V371.862C907.762 408.58 902.788 428.707 896.972 438.872H980.994V343.023H907.762Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1081.64 462.52H1050.31V319.375H1079.35V426.841L1165.04 319.375H1196.16V462.52H1167.32V355.054L1081.64 462.52Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1316.51 319.375L1379.58 462.52H1349.29L1333.31 425.802H1256.75L1240.78 462.52H1213.39L1276.67 319.375H1316.5H1316.51ZM1266.1 404.434H1323.98L1294.94 338.252L1266.11 404.434H1266.1Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2303_1893"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1379.58,
    height: 493.64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.76ec167cfc71b88de713ec7a24ef7cbd.svg";
export { ForwardRef as ReactComponent };